import { Component, Injector, OnInit, resolveForwardRef } from '@angular/core';
import { SelectWidget } from '@app/finxone-web-frontend/app/lib/actions/grid.action';
import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import { getComponentByLabel } from '@app/finxone-web-frontend/app/lib/utils/get-component.utils';
import { getWidgetClasses } from '@app/finxone-web-frontend/app/widget.utis';
import {
  BaseCssProperties,
  NewUiZoneWidgetConfig,
  ProviderClass,
  baseCssConfigStyle,
  cssToNgStyle,
  is2dArray,
  isLayoutWidget,
} from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';
import { createChildWidgetInjector } from '../../zones/utils';
import { ChildComponentList } from '../../zones/widget-layout/main-widget/main-widget.component';

@Component({
  standalone: false,
  selector: 'finxone-web-frontend-two-column-widget',
  template: `
    <section class="d-flex" [ngStyle]="combinedCssOuterStyles">
      <ng-container *ngFor="let columnIndex of getColumnIndexes(); let i = index">
        <div
          [ngStyle]="getEachColumnCss(i)"
          [ngClass]="showGlobalBorderRadius !== 'none' ? showGlobalBorderRadius : ''"
        >
          <section [ngStyle]="columnOuterCss(i)">
            <ng-container *ngFor="let component of getComponentsForColumn(i); let j = index">
              <ng-container *ngIf="configService.getActiveConfigType().isWorkflow; else elseBlock">
                <div
                  [ngClass]="component.widget.uniqueId === mouseOverId ? mouseOver : ''"
                  (click)="selectWidget($event, component.widget)"
                  (mouseover)="changeStyle($event, component.widget.uniqueId.toString())"
                  (mouseout)="changeStyle($event)"
                >
                  <div [class]="getWidgetClasses(component.widget)">
                    <ng-container
                      *ngComponentOutlet="component.component; injector: component.injector"
                    ></ng-container>
                  </div>
                </div>
              </ng-container>
              <ng-template #elseBlock>
                <div [class]="getWidgetClasses(component.widget)">
                  <ng-container
                    *ngComponentOutlet="component.component; injector: component.injector"
                  ></ng-container>
                </div>
              </ng-template>
            </ng-container>
          </section>
        </div>
      </ng-container>
    </section>
  `,
})
export class TwoColumnWidgetComponent implements OnInit {
  injectorComponentsArrays: {
    [key: string]: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      component: any;
      injector: Injector;
      widget: NewUiZoneWidgetConfig;
    };
  }[] = [];
  private columnPercentage = [20, 20];
  public cssStyle: baseCssConfigStyle;
  public eachColumnStyle: baseCssConfigStyle;
  public showGlobalBorderRadius: string;
  public columnGap: string;
  private isWorkflowType: boolean;

  getComponentsForColumn(
    columnIndex: number,
  ): { component: any; injector: Injector; widget: NewUiZoneWidgetConfig }[] {
    return this.injectorComponentsArrays[columnIndex]
      ? Object.values(this.injectorComponentsArrays[columnIndex])
      : [];
  }

  private selectedNoOfColumn = 2;

  mouseOver = '';
  mouseOverId = '';

  changeStyle($event: any, mouseOverId?: string) {
    this.mouseOver = $event.type == 'mouseover' ? 'widget-hover' : '';
    if (mouseOverId) this.mouseOverId = mouseOverId;
    $event.stopPropagation();
  }
  selectWidget(event: MouseEvent, widget: NewUiZoneWidgetConfig) {
    if (this.isWorkflowType) {
      if (event.shiftKey) {
        this.store.dispatch(new SelectWidget(widget.uniqueId.toString(), true));
      } else {
        this.store.dispatch(new SelectWidget(widget.uniqueId.toString(), false));
      }
    }
    event.stopPropagation();
  }

  constructor(
    public childComponents: ChildComponentList,
    private dataIn: ProviderClass<any>,
    private injector: Injector,
    public configService: ConfigService,
    private store: Store,
  ) {
    this.selectedNoOfColumn = this.dataIn.widgetConfig.attributes.widgetProperties?.['selectedNoOfColumn'];
    this.columnPercentage = this.dataIn.widgetConfig.attributes.widgetProperties?.['selectedColumnRange'];

    this.loadCssConfigData();
  }

  getWidgetClasses = getWidgetClasses;

  private getChildComponentOuterCss(index: number) {
    return cssToNgStyle(this.dataIn.widgetConfig.attributes['childComponentOuterCss']?.[index] ?? '');
  }
  get outerCss() {
    return cssToNgStyle(this.dataIn.widgetConfig.attributes.outerCss ?? '');
  }

  get combinedCssOuterStyles() {
    return {
      ...this.cssStyle,
      gap: this.columnGap,
      ...this.outerCss,
    };
  }

  getEachColumnCss(columnIndex: number) {
    const percentage = this.columnPercentage[columnIndex];
    const borderWidthTop = this.dataIn.attri.css_config?.borderWidthTop ?? '0';
    const borderWidthBottom = this.dataIn.attri.css_config?.borderWidthBottom ?? '0';
    const borderWidthLeft = this.dataIn.attri.css_config?.borderWidthLeft ?? '0';
    const borderWidthRight = this.dataIn.attri.css_config?.borderWidthRight ?? '0';
    const borderWidthUnit = this.dataIn.attri.css_config?.borderWidthUnit ?? 'px';
    const borders = {
      'border-width': `${borderWidthTop}${borderWidthUnit} ${borderWidthRight}${borderWidthUnit} ${borderWidthBottom}${borderWidthUnit} ${borderWidthLeft}${borderWidthUnit}`,
    };
    const borderStyle = this.getBorderStyle();
    const boxShadow = this.getBoxShadow();

    return {
      flex: `${percentage}%`,
      ...this.eachColumnStyle,
      ...borderStyle,
      ...boxShadow,
      ...borders,
    };
  }

  private getBorderStyle() {
    let borderStyle = {};
    if (this.showGlobalBorderRadius !== 'none') {
      borderStyle = {
        'border-color': `${this.dataIn.attri?.css_config?.borderColor}`,
        'border-style': `${this.dataIn.attri?.css_config?.borderStyle ?? 'solid'}`,
      };
    }
    return borderStyle;
  }

  public getBoxShadow() {
    return {
      'box-shadow': `${this.dataIn.attri?.css_config?.shadowOffsetX} ${this.dataIn.attri?.css_config?.shadowOffsetY} ${this.dataIn.attri?.css_config?.shadowBlur} ${this.dataIn.attri?.css_config?.shadowSpread} ${this.dataIn.attri?.css_config?.shadowColor}`,
    };
  }

  private loadCssConfigData() {
    this.showGlobalBorderRadius = this.dataIn.attri.css_config?.borderClass ?? 'rad-1';
    this.columnGap = `${this.dataIn.attri.css_config?.columnGap ?? '0'}${
      this.dataIn.attri.css_config?.columnGapUnit ?? 'px'
    }`;

    this.cssStyle = this.configService.getSpecificBaseCssStyle(this.dataIn.attri, [BaseCssProperties.MARGIN]);
    this.eachColumnStyle = this.configService.getSpecificBaseCssStyle(this.dataIn.attri, [
      BaseCssProperties.PADDING,
      BaseCssProperties.BACKGROUND_COLOR,

      ...(this.showGlobalBorderRadius === 'none' ? [BaseCssProperties.BORDER] : []),
    ]);
  }

  getColumnIndexes(): number[] {
    const columns = [];
    for (let i = 0; i < this.selectedNoOfColumn; i++) {
      columns.push(i);
    }
    return columns;
  }

  ngOnInit(): void {
    if (is2dArray(this.childComponents.list)) {
      const columns = this.childComponents.list as NewUiZoneWidgetConfig[][];
      this.injectorComponentsArrays = Array.from(Array(columns?.length), () => {
        return {};
      });
      columns.forEach((columnComponents, index) => {
        columnComponents.forEach((widget) => {
          const component = resolveForwardRef(getComponentByLabel(widget.name));
          this.injectorComponentsArrays[index][widget.uniqueId] = {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            component: component,
            injector: createChildWidgetInjector(
              widget,
              this.injector,
              this.dataIn,
              isLayoutWidget(widget.name)
                ? [
                    {
                      provide: ChildComponentList,
                      useValue: new ChildComponentList(widget.childComponents ?? []),
                    },
                  ]
                : [],
            ),
            widget: widget,
          };
        });
      });
      this.isWorkflowType = this.configService.getActiveConfigType()?.isWorkflow;
    } else {
      throw new Error('Two column widget cannot have one child component arrays or more than 2');
    }
  }

  /**
   * Retrieves the outer CSS styles for a column at a given index.
   *
   * This function checks if the `columnConfigs` array exists in the widget properties.
   * If the specified column index has an `outerCssConfig`, it converts it to an Angular style object.
   * Otherwise, it falls back to fetching the old getChildComponentOuterCss outer CSS function.
   *
   * @param {number} index - The index of the column whose styles need to be retrieved.
   * @returns {Record<string, string>} - The style object.
   */
  public columnOuterCss(index: number): Record<string, string> {
    const columnConfigs = this.dataIn.widgetConfig.attributes.widgetProperties?.['columnConfigs'];
    return columnConfigs?.[index]?.outerCssConfig
      ? cssToNgStyle(columnConfigs[index].outerCssConfig)
      : this.getChildComponentOuterCss(index);
  }
}
